import { render, staticRenderFns } from "./cpxend.vue?vue&type=template&id=fc0d467e"
import script from "./cpxend.vue?vue&type=script&lang=js"
export * from "./cpxend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports